import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Avatar from '../../images/avatar.jpg';
import './css/testimoniials.css';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
      },
  };

const Testimonials = () => {
    return (
        <div className='testimonials'>
            <div className='testimonials-heading'>
                <h2>testimonials</h2>
            </div>
            <div >
                <Carousel
                    infinite={true}
                    showDots={true}
                    draggable={true}
                    swipeable={true}
                    autoPlaySpeed={100}
                    customTransition='all .5'
                    transitionDuration={500}
                    responsive={responsive}
                    className='Testimonials-slider'
                    removeArrowOnDeviceType={["desktop"]}
                    containerClass='carousel-container'
                    dotListClass='custom-dot-list-style'
                    itemClass='carousel-item-padding-40-px'
                >
                    <div className='testimonials-boxes'>
                        <div className='testimonials-avatar'>
                            <img src={Avatar} alt='Harshitha developers clients' height='100%' width='100%' />
                        </div>
                        <div className='testimonials-description'>
                            <p>Hello tom is simply dummy text of the printing and typesetting yes.Lorem Ipsum is simply dummy text of the change and typesetting industry.</p>
                            <p className='testimonials-client'><span>tom --</span> desgnation</p>
                        </div>
                    </div>

                    <div className='testimonials-boxes'>
                        <div className='testimonials-avatar'>
                            <img src={Avatar} alt='Harshitha developers clients' height='100%' width='100%' />
                        </div>
                        <div className='testimonials-description'>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                            <p className='testimonials-client'><span>jerry --</span> desgnation</p>
                        </div>
                        
                    </div>

                </Carousel>
            </div>

        </div>
    )
}

export default Testimonials;